<template>
  <q-btn-toggle
    class="bg-white"
    no-caps
    spread
    padding="sm sm"
    clearable
    :disable="disable"
    :model-value="modelValue"
    :options="formattedOptions"
    :style="toggleStyles"
    @update:model-value="(val) => $emit('update:modelValue', val)"
    @clear="$emit('clear')"
  />
</template>

<script>
/**
 * Custom QBtnToggle which provides support for HEX color buttons
 * Overrides default Quasar implementation
 */
export default {
  props: {
    modelValue: {
      type: [String, Number]
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    disable: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'clear'],
  computed: {
    toggleStyles () {
      return {
        'flex-direction': this.vertical ? 'column !important' : undefined
      }
    },
    // Format the options to support hex colours
    formattedOptions () {
      const arr = []
      for (const ele of (this.options || [])) {
        const row = {
          label: ele.label,
          value: ele.value
        }
        if (this.modelValue === ele.value && ele.hex_color) {
          row.style = {
            'background-color': `${ele.hex_color} !important`,
            'color': `${this.checkBrightnessOfHex(ele.hex_color) > 170 ? '#000' : '#fff'} !important`
          }
        }
        arr.push(row)
      }
      return arr
    }
  }
}
</script>
